import { z } from 'zod';

import { chatUiBase } from '../../shared/schema/base.js';
import { ChatUiFlightCabinSchema } from '../../shared/schema/flight_cabin_schema.js';
import { ChatUiFlightPassengersSchema } from '../../shared/schema/flight_passengers_schema.js';

/**
 * Resumo pré-busca de voo — display-only. Projeção determinística dos args da
 * tool `confirm_flight_search`: a rota (IATA + nome de cidade só p/ exibição),
 * as datas (volta presente ⇒ ida-e-volta), passageiros e classe. NÃO carrega
 * ação — a confirmação acontece na conversa (o cliente responde "sim"); não é
 * um guardrail de ação destrutiva.
 */
const ChatUiFlightSearchConfirmationSchema = z.object({
  origin: z.string().regex(/^[A-Z]{3}$/),
  destination: z.string().regex(/^[A-Z]{3}$/),
  originLabel: z.string().trim().min(1).optional(),
  destinationLabel: z.string().trim().min(1).optional(),
  departureDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  returnDate: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional(),
  passengers: ChatUiFlightPassengersSchema,
  cabin: ChatUiFlightCabinSchema.optional(),
});
export type ChatUiFlightSearchConfirmation = z.infer<typeof ChatUiFlightSearchConfirmationSchema>;

/** Membro `flight_search_confirmation` do `ChatUiSchema` (discriminatedUnion). */
export const FlightSearchConfirmationBlockSchema = z
  .object({
    ...chatUiBase,
    kind: z.literal('flight_search_confirmation'),
    search: ChatUiFlightSearchConfirmationSchema,
  })
  .strict();
